import * as React from "react"
import { ModalSeeker } from "@ui-seeker/core"

import AdminSkuModalContent from "./Content"
import { useAdminSkuModal } from "../@hooks"
import { disabledAdminSkuModal, isOpenModalAdminSku } from "../@signals"


export default function AdminSkuModal() {
    const { isLoading, handleMerge } = useAdminSkuModal()

    return <ModalSeeker
        isOpen={isOpenModalAdminSku.value}
        title="Merge SKUs"
        controller={() => isOpenModalAdminSku.value = false}
        successProps={{
            disabled: disabledAdminSkuModal.value,
            loading: isLoading,
            onClick: handleMerge
        }}
    >
        <AdminSkuModalContent />
    </ModalSeeker>
}